import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../../components/Layout';
import Header from './Header';
import List from './List';
import * as shapes from '../shapes';
import * as commonShapes from '../../../../common/shapes';
import HistoryContainer from '../history/HistoryContainer';
import Money from '../../../../common/money';

const WithCommissionSplits = ({
  serviceItems,
  fromDate,
  toDate,
  lastTransferDate,
  processPayout,
  productItems,
  toggleAutoDeposit,
  autoDepositChecked,
  processing,
  totalAvailableForPayout,
  giftCardTipsAmount,
}) => (
  <Layout title="Payouts">
    <Header
      fromDate={fromDate}
      toDate={toDate}
      lastTransferDate={lastTransferDate}
      toggleAutoDeposit={toggleAutoDeposit}
      autoDepositChecked={autoDepositChecked}
    />
    <button
      className="c-btn u-mb+"
      type="button"
      onClick={processPayout}
      display-if={!autoDepositChecked}
      disabled={processing}
    >
      Initiate transfer
    </button>
    <div className="layout">
      <div className="layout__item u-1/2">
        <h3 className="u-mb-">Services</h3>
      </div>
      <div className="layout__item u-1/2 u-text-right">
        <h5 className="u-mb-0">
          Total funds available for payout: <Money cents={totalAvailableForPayout} />
        </h5>
        <h5 className="u-mb--">
          Gift Card Tips Transferred: <Money cents={giftCardTipsAmount} />
        </h5>
      </div>
    </div>
    <List items={serviceItems} />
    <h3 className="u-mt u-mb-">Products</h3>
    <List items={productItems} />
    <HistoryContainer />
  </Layout>
);
WithCommissionSplits.propTypes = {
  serviceItems: shapes.commissionSplitReport,
  fromDate: commonShapes.date,
  toDate: commonShapes.date,
  lastTransferDate: commonShapes.date,
  processPayout: commonShapes.handler,
  productItems: shapes.commissionSplitReport,
  autoDepositChecked: PropTypes.bool.isRequired,
  toggleAutoDeposit: PropTypes.func.isRequired,
  processing: PropTypes.bool.isRequired,
  totalAvailableForPayout: PropTypes.number,
  giftCardTipsAmount: PropTypes.number,
};

WithCommissionSplits.defaultProps = {
  serviceItems: [],
  fromDate: '',
  toDate: '',
  lastTransferDate: '',
  processPayout: () => null,
  productItems: [],
  totalAvailableForPayout: 0,
  giftCardTipsAmount: 0,
};

export default WithCommissionSplits;
